import { Tooltip as AntTooltip } from "antd";
import React from "react";

import { NewBranch as GenericBranch } from "~/Branch";
import * as Driver from "~/Driver";

export type Props = {
  readonly driver?: Driver.Driver;
};
export namespace Branch {
  export const Name = ({
    branch,
  }: {
    readonly branch?: GenericBranch.Branch;
  }) => {
    const branchName = GenericBranch.name(branch);
    return (
      <div data-testid="branch-name-tooltip-wrapper">
        {branch?.name ? (
          <AntTooltip title={GenericBranch.TooltipTitle("Driver's branch:", branchName)} mouseEnterDelay={0.5}>
            {branchName}
          </AntTooltip>
        ) : (
          <>{branchName}</>
        )}
      </div>
    );
  };
}
